/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementVideoIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="ElementVideoIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4 3.41905C4 2.63812 4.8551 2.15855 5.52145 2.56577L13.0626 7.17424C13.7007 7.56417 13.7007 8.49087 13.0626 8.8808L5.52145 13.4893C4.8551 13.8965 4 13.4169 4 12.636V3.41905ZM12.5411 8.02752L5 3.41905V12.636L12.5411 8.02752Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

ElementVideoIcon.tags = [
  'video',
  'videos',
  'play',
  'player',
  'start',
  'arrow',
  'media',
  'triangle',
  'forward',
];

ElementVideoIcon.category = 'Navigator';

ElementVideoIcon.iconSize = 16;
